import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=160064d0&scoped=true"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&id=160064d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160064d0",
  null
  
)

export default component.exports